export default __webpack_public_path__ + "static/media/user-blue.022f390c.png";